define(function(require, exports, module) {
    'use strict';

    const BaseModel = require('common/base.model');
    const server = require('server');

    module.exports = BaseModel.extend({

        parse: function(response) {
            return response?.data || [];
        },

        sync: function(method, model, options) {
            if (method !== 'read') {
                return;
            }

            return this._loadDetails(method, model, options);
        },

        _loadDetails: function(method, model, options) {
            return server.send({
                ID: 35506,
                responses: [35507, 35509],
                description: 'Get Balance Breakdown (from bonus counter)',
                balanceType: 'casino_gaming_balance'
            }).then(options.success, options.error);
        }
    });
});
